import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'

export default withTranslation()(function ProofOfPayoutModal({ t, imageUrl, onClose }) {
  return (
    <div className="fixed inset-0 z-[5000] bg-black bg-opacity-30 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white relative w-11/12 max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl p-6" onClick={(event) => event.stopPropagation()}>
        <div className="relative flex items-center justify-center mb-4">
          <button type="button" onClick={onClose} className="absolute left-0 text-secondary hover:text-dark-blue">
            <UIcons.UilTimes size={22} />
          </button>

          <h3 className="text-xl font-bold text-dark-blue">{t('payout.winner_detail.proof.title')}</h3>
        </div>

        <img src={imageUrl} alt="" className="w-full rounded-xl object-cover" />
      </div>
    </div>
  )
})
